import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BaseModule } from 'shared/base/base.module'
import { AppMaterialModule } from '../app-material.module'
import { SharedComponentModule } from '../shared/shared-components.module'
import { AuthRoutingModule } from './auth-routing.module'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SharedComponentModule,
    AuthRoutingModule,
    AppMaterialModule,
    BaseModule,
  ],
})
export class AuthModule {}
